export * from '@primeuix/themes/nora/badge';
export { default } from '@primeuix/themes/nora/badge';
